import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue';
import ColorPicker from '@/components/widgets/ColorPicker';


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorPickerDropdown',
  props: {
    selectedColor: {},
    colors: {}
  },
  emits: ['colorSelect', 'focusChange', 'predefinedColorPick'],
  setup(__props: any, { emit: __emit }) {

let vertical = ref(false);
let isInViewportTimeout: ReturnType<typeof setTimeout>;
let show = ref(false);



const emit = __emit;

const pickerWrap = ref();

onMounted(() => {
  isInViewportTimeout = setTimeout(() => {
    const { width: windowWidth } = document.documentElement.getBoundingClientRect();
    const { right } = pickerWrap.value.getBoundingClientRect();

    if (right > windowWidth) {
      vertical.value = true;
    }
    show.value = true;
  }, 0);
});

onUnmounted(() => {
  clearTimeout(isInViewportTimeout);
});

function handleColorItemClick(color: string) {
  emit('colorSelect', color);
}

function handlePredefinedColorPick(color: string) {
  emit('predefinedColorPick', color);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "pickerWrap",
    ref: pickerWrap,
    class: _normalizeClass(["color-picker-dropdown-wrap", { vertical: _unref(vertical), invisible: !_unref(show) }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('focusChange')), ["stop"]))
  }, [
    _createVNode(_unref(ColorPicker), {
      "selected-color": _ctx.selectedColor,
      colors: _ctx.colors,
      onSelectColor: handleColorItemClick,
      onPredefinedColorPick: handlePredefinedColorPick
    }, null, 8, ["selected-color", "colors"])
  ], 2))
}
}

})